export default __webpack_public_path__ + "static/media/3_size_type01_unselected_icon.9ad32063.jpg";